import { useActions, useAppState } from '@/overmind';

export function useSelectedFeature() {
  const selectedFeature = useAppState().selectedFeature.current;
  const { setSelectedFeature, unselectFeature } = useActions().selectedFeature;

  return { selectedFeature, setSelectedFeature, unselectFeature };
}
